import index from '../api/index'

export const Login = (query) => {
    return new Promise((resolve) => {
        resolve(index.auth.Login(query))
    })
}